// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tabs-container[data-v-7a9cfe80] {\n  position: absolute;\n  top: 10px;\n  left: 50%;\n  max-width: 240px;\n  height: 64px;\n  transform: translate(-50%, 0);\n  z-index: 1002;\n}\n[data-v-7a9cfe80] .van-tabs__nav {\n  background-color: transparent;\n}\n[data-v-7a9cfe80] .van-tab__text--ellipsis {\n  font-size: 20px;\n  font-weight: 500;\n}\n[data-v-7a9cfe80] .van-tab {\n  white-space: nowrap;\n  padding: 0 12px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
